<template>
    <div>
        <homeHead></homeHead>
        <homeNav  :type="1" ></homeNav>
        <div class="pre-box"  v-if="preview==1" >
            <p>当前文章仅用于预览！</p>
        </div>
        <div class="colspan">
            <div class="weizhi"> <img src="../../assets/images/weizhi.png" alt=""> 您当前所在的位置：</div>
            <el-breadcrumb separator="/"> 
                <el-breadcrumb-item>新闻详情</el-breadcrumb-item>  
            </el-breadcrumb>
        </div>
        <detailsInfo :detailData="detailData" ></detailsInfo>
        <homeFooter></homeFooter>
    </div>
</template>
<script>
import homeHead from '@/components/Public/head.vue'
import homeNav from '@/components/Public/nav.vue'
import detailsInfo from './detailsInfo.vue'
import homeFooter from '@/components/Public/footer.vue'
    export default {
        components:{
            homeHead,
            homeNav,
            detailsInfo,
            homeFooter,
        },
        data(){
            return {
                id:null, //一级导航
                second_navId:null,//二级导航
                positionData:[],//当前位置  
                detailData:{},
                newsId:null,// 
                preview:'',
            }
        },
        methods:{
                    
        },
        created(){

            this.newsId = Number(this.$route.query.newsId)  
            this.id     = Number(this.$route.query.id) 
            this.preview = this.$route.query.preview
            // this.second_navId = Number(this.$route.query.second_navId)   

            if(this.$route.query.id ){
                this.$db.get(this.$url.channel.childList+'?id='+this.id).then(res=>{
                    this.positionData = res.data
                }).catch(err => {
            console.log(err);
          });
            }

            this.$db.get(this.$url.document.url+"/"+this.newsId).then(res=>{
                this.detailData = res.data
            }).catch(err => {
            console.log(err);
          });
        }
    }
</script>
<style lang="less" scoped>
    .colspan {
        margin: 0 auto;
        width: 1200px;
        height: 50px;
        background-color: #f3f3f3;
        color: #888888;
        font-size: 16px;
        margin-top: 14px;
        margin-bottom: 20px;
        > .weizhi {
            float: left;
            line-height: 50px;
            margin-left: 10px;
            > img {
                vertical-align:text-top;  
            }
        }
        > .el-breadcrumb {
            line-height: 50px;
        }
    }
    .pre-box{
        height: 50px;
        margin: 0 auto;
        width: 1200px;
        background-color: bisque;
        >p{
            text-indent:15px;
            color: #ab0f13;
            line-height: 50px;
            font-size: r(24);
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/dynamics/pubDetails.vue